import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import BookAppointmentCalendly from "./BookAppointmentCalendly";
import BookAppointmentPayFirst from "./BookAppointmentPayFirst";

export default function BookAppointment() {
  const [payFirst, setPayFirst] = useState(null);
  useEffect(() => {
    api.get("/booking/config").then(({ data }) => setPayFirst(!!data.pay_first)).catch(() => setPayFirst(false));
  }, []);
  if (payFirst === null) return <div data-testid="book-appointment-loading" className="min-h-[60vh]" />;
  return payFirst ? <BookAppointmentPayFirst /> : <BookAppointmentCalendly />;
}
